import { uniq } from "lodash-es";

import normalizeEmail from "./normalizeEmail";

const areEmailsEqual = (...emails: (null | string | undefined)[]): boolean => {
  return uniq(emails.map((email) => normalizeEmail(email))).length === 1;
};

export default areEmailsEqual;
